import { Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-usernameless-modal',
    templateUrl: './usernameless-modal.component.html',
    styleUrls: ['./usernameless-modal.component.scss'],
    imports: [TranslatePipe]
})
export class UsernamelessModalComponent implements OnInit {
  private modal = inject(NgbActiveModal);


  ngOnInit(): void {
  }

  close(result: boolean): void {
    this.modal.close(result);
  }

}
